// UI constants

// Header
export const SCROLL_THRESHOLD = 50 // header becomes sticky at this height

// Snackbar
export const SNACKBAR_DURATION_SECONDS = 3 // default duration for snackbar messages

export const IMAGE_NOT_FOUND_ALT_TEXT = 'Image Not Found'

// useForm Custom Validators
export const INVALID = 'Invalid'
export const SELECT_COUNTRY = 'Select Country'
export const SELECT_STATE_PROVINCE = 'Select State/Province'
export const VALIDATOR_CONTAINS_INVALID_USERNAME_SYMBOLS = "Contains symbols other than .',&-_"
export const VALIDATOR_EMAILS_DO_NOT_MATCH = 'Email addresses do not match.'
export const VALIDATOR_EXPIRED_EXPIRATION_DATE = 'Expiration date has passed.'
export const VALIDATOR_INVALID_CREDIT_CARD_NUMBER = 'Invalid credit card number.'
export const VALIDATOR_INVALID_EXPIRATION_MONTH = 'Invalid expiration month.'
export const VALIDATOR_INVALID_MEMBER_NUMBER = 'Invalid member number; 9-11 numbers required.'
export const VALIDATOR_INVALID_NAME = 'Invalid name; Please use only alphabetic characters, spaces, and hyphens.'
export const VALIDATOR_INVALID_OWNER_NUMBER = 'Invalid owner number; 11 numbers required.'
export const VALIDATOR_INVALID_CONTRACT_NUMBER = 'Contract number must be alphanumeric and 1-12 characters long.'
export const VALIDATOR_INVALID_CREDIT_CARD = 'Please provide a valid credit card number.'
export const VALIDATOR_INVALID_PHONE_NUMBER = 'Invalid phone number.'
export const VALIDATOR_INVALID_PHONE_NUMBER_FOR_X = (countryCode: string): string => `Invalid phone number for ${countryCode.toUpperCase()}.`
export const VALIDATOR_INVALID_POSTAL_CODE_FOR_X = (countryCode: string): string => `Invalid postal code for ${countryCode.toUpperCase()}.`
export const VALIDATOR_INVALID_USERNAME_CHARACTERS = "Contain only letters (a-z, A-Z), numbers (0-9), and/or special symbols: (.',&-_)."
export const VALIDATOR_INVALID_USERNAME = 'Invalid username; only letters, numbers, some special symbols are allowed.'
export const VALIDATOR_MATCHES_FORMAT_X = (formatExample: string): string => `Please match the format: ${formatExample}.`
export const VALIDATOR_MAX_LENGTH_X = (maxLength: number): string => `Exceeds maximum of ${maxLength} character${maxLength > 1 ? 's' : ''}.`
export const VALIDATOR_MIN_LENGTH_X = (minLength: number): string => `Please provide ${minLength} characters.`
export const VALIDATOR_MINIMUM_PASSWORD_LENGTH = 8
export const VALIDATOR_MINIMUM_USERNAME_LENGTH = 6
export const VALIDATOR_PASSWORD_STRENGTH_NOT_MET = 'Password is not strong enough.'
export const VALIDATOR_REQUIRES_X_CHARACTERS = (minLength: number): string => `At least ${minLength} character${minLength > 1 ? 's' : ''}.`
export const VALIDATOR_REQUIRES_X_LOWERCASE = (min: number): string => `At least ${min} lowercase letter${min > 1 ? 's' : ''} (a-z)`
export const VALIDATOR_REQUIRES_X_NUMBERS = (min: number): string => `At least ${min} number${min > 1 ? 's' : ''} (0-9)`
export const VALIDATOR_REQUIRES_X_UPPERCASE = (min: number): string => `At least ${min} uppercase letter${min > 1 ? 's' : ''} (A-Z)`
export const VALIDATOR_REQUIRES_X_SYMBOLS = (min: number): string => `At least ${min} symbol${min > 1 ? 's' : ''}`
export const VALIDATOR_STARTS_WITH_LETTER = 'Start with a letter.'
export const VALIDATOR_VALUES_DO_NOT_MATCH = 'Values do not match.'
export const YOUR_PASSWORD_MUST_CONTAIN = 'Your new password must contain:'
export const HIGHLIGHT_CARD_LINK_ICON = 'arrow-right'
export const HIGHLIGHT_CARD_LINK_LABEL = 'Learn More'
